import React, {Component} from 'react';
import ReactDOM from "react-dom";

class JunkSize extends Component {

    constructor(props) {
        super(props);

        this.size = (this.props.size !== '' ? JSON.parse(this.props.size) : '');

        this.state = {
            size_uk: this.size.size_uk || '',
            size_metric: this.size.size_metric || '',
            max_weight: this.size.max_weight || '',
            similar_to: this.size.similar_to || '',
            price: this.size.price || ''
        };

        this.handleUKChange = this.handleUKChange.bind(this);
        this.handleMetricChange = this.handleMetricChange.bind(this);
        this.handleMaxWeightChange = this.handleMaxWeightChange.bind(this);
        this.handlePriceChange = this.handlePriceChange.bind(this);
        this.handleSimilarChange = this.handleSimilarChange.bind(this);
    }

    handleUKChange(e) {
        let size_metric = Math.round((e.target.value * 0.764555 * 100)) / 100;
        this.setState({
            size_uk: e.target.value,
            size_metric: size_metric
        });
    }

    handleMetricChange(e) {
        let size_uk = Math.round(e.target.value / 0.764555 * 100) / 100;
        this.setState({
            size_uk: size_uk,
            size_metric: e.target.value
        });
    }

    handleMaxWeightChange(e) {
        this.setState({
            max_weight: e.target.value
        });
    }

    handlePriceChange(e) {
        this.setState({
            price: e.target.value
        })
    }

    handleSimilarChange(e) {
        this.setState({
            similar_to: e.target.value
        });
    }

    render() {
        return (
            <React.Fragment>
                <div className="col-md-4 col-size">
                    <div className="input-group">
                        <div className="input-group-prepend">
                            <div className="input-group-text">y<sup>3</sup></div>
                        </div>
                        <input type="number"
                               className="form-control"
                               name="size_uk"
                               onChange={this.handleUKChange}
                               value={this.state.size_uk}
                               required
                               placeholder="Size(UK)..."/>
                    </div>
                </div>
                <div className="col-md-4 col-size">
                    <div className="input-group">
                        <div className="input-group-prepend">
                            <div className="input-group-text">m<sup>3</sup></div>
                        </div>
                        <input type="number"
                               className="form-control"
                               name="size_metric"
                               onChange={this.handleMetricChange}
                               value={this.state.size_metric}
                               required
                               placeholder="Size(metric)..."/>
                    </div>
                </div>
                <div className="col-md-4 col-size">
                    <div className="input-group">
                        <div className="input-group-prepend">
                            <div className="input-group-text">kg</div>
                        </div>
                        <input type="number"
                               className="form-control"
                               name="max_weight"
                               onChange={this.handleMaxWeightChange}
                               value={this.state.max_weight}
                               required
                               placeholder="Max weight..."/>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

if (document.getElementById('editJunkSize')) {
    let element = document.getElementById('editJunkSize');
    ReactDOM.render(<JunkSize size={element.dataset.size}/>, element);
}


export default JunkSize;

